import React from "react";
import useMatricula from "../../hooks/useMatricula";


const ModalConfirmacionFranjaHorario = ({ franja, guardarSeleccion }) => {

  let { franjaActual, setFranjaSeleccionadaHorario, setMostrarAsignaturas } = useMatricula()


  const handleClose = () => {
    setFranjaSeleccionadaHorario(franjaActual)
    setMostrarAsignaturas(true)
  }

  return (
    <div
      className="modal hide fade"
      id="confirmacion-horario-franja"
      tabIndex={-1}
      aria-labelledby="confirmacion-horario-franja1"
      aria-hidden="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0">
            <h5 className="modal-title" id="confirmacion-horario-franja1" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            />
          </div>
          <div className="modal-body">
            <div className="text-center px-3">
              <h5 className="text-uppercase ">
                ¿Seguro que desea seleccionar <br /> la franja <strong>"{franja}"</strong>?
              </h5>
              <p>
                {" "}
                Está seleccionando la franja <strong> {franja}</strong>. Se le asignarán los cursos correspondientes a la franja.
              </p>
              <p>
                Perderá la oferta seleccionada de la franja anterior.              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={guardarSeleccion}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmacionFranjaHorario;
